import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beachtennis-ranking-history',
  templateUrl: './beachtennis-ranking-history.component.html',
  styleUrls: ['./beachtennis-ranking-history.component.scss']
})
export class BeachtennisRankingHistoryComponent implements OnInit {
  /**
   * Definição do tipo de departamento para sessão/depto Profissional
   */
  departmentType: string = '2';

  constructor() { }

  ngOnInit(): void {
  }

}
